import { motion } from "framer-motion";
import CustomLists from '@/components/elements/CustomLists/CustomLists';
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Table from '@/components/elements/Table/Table';
import TitleBar from '@/components/elements/TitleBar/TitleBar';
import TitleWithContent from '@/components/elements/TitleWithContent/TitleWithContent';
import vistacrystalplusImg from '@/assets/images/products/vistacrystalplus.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaCrystalPlus = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar title="Vista Crystal Plus" />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Crystal Plus"
          title="Description"
          imageUrl={vistacrystalplusImg}
          content="Vista Crystal Plus is a crystalline waterproofing admixture that protects and waterproofs concrete structures through crystallization. The active chemicals react with moisture and the by-products of cement hydration in the concrete, resulting in crystalline formation within the pores and capillary tracts of concrete. This waterproofs the structure against the penetration of water and other liquids from any direction. Crystal Plus provides strong and lasting protection against harsh environmental conditions. When combined with water, the chemicals form millions of needle-like crystals within the concrete, filling pores and micro-cracks, and effectively blocking water pathways."
        />
      </motion.div>


      <motion.div {...fadeInUp}>
        <TitleWithContent title="Features">
          <CustomLists
            items={[
              [
                "Crystalline cementitious material",
                "Integral addition",
              ],
              [
                "Reduces concrete permeability",
                "Reduces concrete breathability",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Benefits">
          <CustomLists
            items={[
              [
                "Reduces penetration of water and other liquids",
                "Seals hairline cracks",
              ],
              [
                "Resists positive and negative side hydrostatic pressure",
                "Protects against sewage and industrial wastes",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Application">
          <CustomLists
            items={[
              [
                "Foundations",
                "Sewage and water treatment plants",
                "Tanks",
                "Underground vaults",
                "Tunnel and subway systems",
              ],
              [
                "Water reservoirs",
                "Secondary containment structures",
                "Below-grade parking structures",
                "Precast components",
                "Swimming pools",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Reduction in water penetration",
                "Improves durability",
              ],
              [
                "‘Self-healing’ concrete",
                "Extends longevity",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Technical Data">
          <Table
            items={{
              headings: [],
              rows: [
                ["Form", "Powder"],
                ["Color", "Grey"],
                ["Density of dry mortar", "0.97 ± 0.1 Kg/l"],
                ["Maximum chloride content", "Chloride-free"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaCrystalPlus;
